import BaseAPI from "../api";

const path: string = "/advisor-type";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class advisorTypeApi extends BaseAPI {
  static getAllAdvisorType(query?: listType, token?: string): Promise<any> {
    if (!token){
      return this.api.get(`${path}`, {
        params: { ...query },
      });
    } else {
      return this.api.get(`${path}`, {
        params: { ...query },
        headers: { Authorization: `Bearer ${token}` },
      });
    }

  }

  static getAdvisorTypeById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static createAdvisorType(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateAdvisorType(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteAdvisorType(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
